var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Modal } from './Modal';
import { validate } from 'email-validator';
import { MAIN_BACKEND_URL } from "../data/API";
const $ = window.$;
export class Login extends React.Component {
    constructor(props) {
        super(props);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const returnUrl = urlParams.get("return_url");
        this.state = {
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            state: 'email',
            returnUrl
        };
        this.emailRef = React.createRef();
        this.passwordRef = React.createRef();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: this.state.state == 'email' ? '' : 'hidden' },
                React.createElement("label", null, "Email"),
                React.createElement("input", { "data-cs-mask": true, ref: this.emailRef, type: "email", name: "customer[email]", className: "large", placeholder: "Enter your email address", value: this.state.email, onChange: (evt) => this.setState({ email: evt.target.value }), onKeyUp: (evt) => this.nextStepkeyUp(evt) })),
            React.createElement("div", { className: this.state.state == 'password' ? '' : 'hidden' },
                React.createElement("a", { onClick: () => this.back(), style: { display: 'block', color: '#02abe3' } }, "\u2190 Back"),
                React.createElement("small", { className: "right" },
                    React.createElement("em", null,
                        React.createElement("a", { href: "#", "aria-label": "Navigate to Reset Password Form", onClick: window.showRecoverPasswordForm }, "Forgot your password?"))),
                React.createElement("label", null, "Password"),
                React.createElement("input", { "data-cs-mask": true, ref: this.passwordRef, type: "password", name: "customer[password]", className: "large password", value: this.state.password, onChange: (evt) => this.setState({ password: evt.target.value }), onKeyUp: (evt) => this.nextStepkeyUp(evt) })),
            React.createElement("input", { className: "btn action_button kapra", type: "button", onClick: () => this.nextStep(), value: this.state.state == 'email' ? 'Next' : 'Login' }),
            React.createElement("p", { className: "right", style: { paddingTop: '10px' } },
                "New Customer? ",
                React.createElement("a", { href: this.state.returnUrl ? "/account/register?return_url=" + this.state.returnUrl : "/account/register", id: "customer_register_link" }, "Sign up \u2192"))));
    }
    nextStep() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state.state == 'email') {
                if (validate(this.state.email)) {
                    this.checkEmail();
                }
                else {
                    Modal.open('Oops!', React.createElement("p", null, "Please enter a valid email."), 'Ok');
                }
            }
            else {
                this.login();
            }
        });
    }
    nextStepkeyUp(evt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (evt.keyCode === 13)
                this.nextStep();
        });
    }
    checkEmail() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${MAIN_BACKEND_URL}/hasaccount/${this.state.email}`;
            var hasAccount = yield window.$.getJSON(url);
            if (hasAccount) {
                this.setState({ state: 'password' });
                this.passwordRef.current.focus();
            }
            else {
                Modal.open('Create Account', `Let's finish setting up your account.`, 'Ok', () => {
                    let url = "/account/register?email=" + this.state.email;
                    if (this.state.returnUrl)
                        url += '&return_url' + this.state.returnUrl;
                    window.location.href = url;
                });
            }
        });
    }
    login() {
        const form = document.getElementById('login_form').getElementsByTagName('form')[0];
        form.submit();
    }
    back() {
        this.setState({ state: 'email' });
        setTimeout(() => this.emailRef.current.focus(), 100);
    }
}
